export default $client => ({
    get(page) {
        return $client.get('users', {
            params: {
                page
            }
        })
    },
});
